import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "item", "actionSelect", "submit", "count"];

  connect() {
    this.update();
  }

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.selectAllTarget.checked; });
    this.update();
  }

  update() {
    const selected = this.itemTargets.filter((item) => item.checked).length;
    const allSelected = this.itemTargets.length > 0 && selected === this.itemTargets.length;
    this.selectAllTarget.checked = allSelected;
    this.selectAllTarget.indeterminate = selected > 0 && !allSelected;
    if (this.hasCountTarget) this.countTarget.textContent = `已选择 ${selected} 个`;
    if (this.hasSubmitTarget) this.submitTarget.disabled = selected === 0 || !this.actionSelectTarget.value;
  }

  confirm(event) {
    const selected = this.itemTargets.filter((item) => item.checked).length;
    if (selected === 0 || !this.actionSelectTarget.value) {
      event.preventDefault();
      return;
    }
    if (this.actionSelectTarget.value === "delete" && !window.confirm(`确定删除选中的 ${selected} 个横幅？`)) {
      event.preventDefault();
    }
  }
}
